
import { defineComponent } from 'vue'
import EventCard from '@/components/block/EventCard.vue'
import {
  getEventTerm,
  getEventPlace,
  getEventTypes
} from '@/utils/commonMethods'

export default defineComponent({
  name: 'EventCardActive',
  components: {
    EventCard
  },
  props: {
    event: Object,
    rectangle: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      getEventTerm,
      getEventPlace,
      getEventTypes
    }
  }
})
